import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styles from "../assets/css/Confirmation.module.css";
import Header from "../components/Header";
import List from "../components/List";
import { BASE_URL } from "../constants/constants";

const Confirmation = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 15;
  const token = localStorage.getItem("token");

  const headers = {
    Authorization:
      `Bearer ${token}`,
  };
  const getUsers = (page = 1) => {
    axios
      .get(
        `${BASE_URL}/v0/users/manual-verify?Page=${page}&Size=${itemsPerPage}`,
        { headers }
      )
      .then((response) => {
        console.log(response.data.result);
        setUsers(response.data.result);
        setTotalPages(
          Math.ceil(response.data.metadata.paginationCount / itemsPerPage)
        );
      })
      .catch((error) => {
        console.error("There was an error fetching the users!", error);
      });
  };

  useEffect(() => {
    getUsers(currentPage);
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.box}>
            <div className={styles.text}>Верификация пола <span>{users.length}</span></div>
          </div>
          <div className={styles.container2}>
            {users.map((el) => (
              <div key={el.id}>
                <div className={styles.block}>
                  <div className={styles.name}>
                    {el.firstName || "Пользователь"}
                  </div>
                  <div className={styles.box1}>
                    <div className={styles.phone}>{el.phoneNumber}</div>
                    <button
                      onClick={() => navigate(`/userVerification/${el.id}`)}
                      className={styles.adminbtn}
                    >
                      <div className={styles.description}>Подробнее</div>
                      <img
                        className={styles.nexticon}
                        src="/images/Vector.svg"
                        alt="next icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.block1}>
            <div className={styles.paginate}>
              <div className={styles.box3}>
                <img
                  className={styles.paginationicons}
                  src="/images/left.svg"
                  alt="left icon"
                  onClick={() => handlePageChange(currentPage - 1)}
                />
              </div>
              <div className={styles.page}>
                {currentPage} / {totalPages}
              </div>
              <div className={styles.box4}>
                <img
                  className={styles.paginationicons}
                  src="/images/right.svg"
                  alt="right icon"
                  onClick={() => handlePageChange(currentPage + 1)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
